import React from "react";
import "./notFound.scss";

function NotFound() {
  return (
    <div className="not-found">
      <div className="not-number">404</div>
      <div className="not-text">Ничего не найдено...</div>
    </div>
  );
}

export default NotFound;
